module.exports = __webpack_public_path__ + "images/emoji/bird.8f87655e66372bdb472f.png";